// extracted by mini-css-extract-plugin
export default {"wrapper":"Article_wrapper__KW6mK"};